import React from "react";
import { TermsOfUseContent } from "./TermsOfUseContent";

function TermsAndConditions() {
  return (
    <div id="terms" className="modal fade" role="dialog" aria-hidden="true">
      <div
        className="modal-dialog modal-xl modal-dialog-centered"
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Terms of Use</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body p-4">
            <TermsOfUseContent />
          </div>
        </div>
      </div>
    </div>
  );
}

export default TermsAndConditions;
